import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent } from '../button';
import { IconComponent } from '../icon';

@Component({
  selector: 'cm-success-screen',
  standalone: true,
  imports: [ButtonComponent, IconComponent],
  templateUrl: './success-screen.component.html',
  styleUrl: './success-screen.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessScreenComponent {
  public readonly title = input.required<string>();
  public readonly message = input.required<string>();
  public readonly entityName = input<string>('');
  public readonly primaryLabel = input.required<string>();
  public readonly primaryIcon = input<string>('');
  public readonly primaryAutId = input<string>('success-primary-action');
  public readonly secondaryLabel = input.required<string>();
  public readonly secondaryAutId = input<string>('success-secondary-action');

  public readonly primaryClick = output<void>();
  public readonly secondaryClick = output<void>();
}
